import { useContext } from 'react';
import { CopilotContext } from '../context/copilot-context';

/**
 * Hook to access the Copilot context
 * @returns The Copilot context state and methods
 */
export const useCopilot = () => {
  const context = useContext(CopilotContext);
  
  if (context === undefined) {
    throw new Error('useCopilot must be used within a CopilotProvider');
  }
  
  return context;
};
